// extracted by mini-css-extract-plugin
module.exports = {"card":"Team_card__-6poS","footer":"Team_footer__3-L7v"};